import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Typography from 'components/atoms/Typography/Typography';
import { useIconButtonStyles } from './iconButtonStyles';

/**
 * Icon Button component composed of https://material-ui.com/api/svg-icon/ and https://material-ui.com/api/typography/
 * @param {} props All possible props can be found in docs https://material-ui.com/api/svg-icon/ and https://material-ui.com/api/typography/
 */
export default function IconButton(props) {
  const { children, ...rest } = props;
  const classes = useIconButtonStyles(props);

  const onButtonClick = () => {
    if (props.onButtonClick) {
      props.onButtonClick();
    }
  };

  return (
    <Box
      className={classes.iconButton}
      onClick={() => {
        onButtonClick();
      }}
    >
      <Box display="flex" justifyContent="center">
        {children}
      </Box>
      <Box>
        <Typography
          className={classes.text}
          variant="button"
          textColor={props.textColor ? props.textColor : 'inherit'}
        >
          {props.buttonLabel}
        </Typography>
      </Box>
    </Box>
  );
}

IconButton.propTypes = {
  /**
   * Svg icon
   */
  children: PropTypes.node.isRequired,
  /**
   * Button label
   */
  buttonLabel: PropTypes.string,
  /**
   * Icon button color
   */
  color: PropTypes.string,
  /**
   * Icon button color on hover
   */
  hoverColor: PropTypes.string,
  /**
   * Underline of button label
   */ underline: PropTypes.bool,
  /**
   * Defines what happens on button click
   */
  onButtonClick: PropTypes.func,
};
